import React from "react";
import { Route, Switch } from "react-router-dom";
import { Crumb } from "@repoflow/components/breadcrumb";
import * as Section from "@repoflow/components/section";
import SiteDomainPublicSchema from "@common/schema/site-domain/public";

import * as ListRoute from "./list";
import * as NewRoute from "./new";

// The hostnames a site is served on.
//
// A section of its own rather than a panel on the site screen, because the two
// screens under here are a listing and a create form — the same shape pages and
// sections have — and because the site screen already carries the document
// shell behind one Save.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/domain`;
  const basepath = `${parentBasepath}/domain`;

  return (
    <Section.Provider
      schema={SiteDomainPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <Crumb to={`${base}`} label={"Domains"} />
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
